import tw from 'twin.macro';

export const Form = tw.form`
   w-full flex justify-center items-center 
   gap-2 px-5 pt-7 pb-4 
`;
